import React from 'react'

import { Row, Box, Skeleton } from 'components/_new/layout'

import s from './DeliveryProductListCardSkeleton.scss'


const DeliveryProductListCardSkeleton = () => (
  <Row align="stretch">
    <Box mr={16}>
      <Skeleton w={88} h={88} />
    </Box>
    <div className={s.content}>
      <div className={s.mainContent}>
        <Skeleton pw={40} h={20} />
        <Box mt={8} noWrapper>
          <Skeleton pw={70} h={14} />
        </Box>
      </div>
      <Box mt={16}>
        <Skeleton pw={50} h={20} />
      </Box>
    </div>
  </Row>
)


export default DeliveryProductListCardSkeleton
